export { default } from "bullitttime-embermodelsevent/models/team-result";
